import styled from "@emotion/styled";
import Collapse from "global/components/Collapse";
import {
  buttonUnstyled,
  utilityPrimary,
  defaultFocusStyle
} from "theme/styles/mixins";

export const Toggle = styled(Collapse.Toggle)`
  ${buttonUnstyled}
  ${utilityPrimary}

  --_toggle-arrow-transform: rotate(0deg);

  text-align: inherit;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding-block: 2px;
  margin-block-start: 4px;

  &:has(+ *) {
    margin-block-end: 6px;
  }

  &:hover {
    color: inherit;
  }

  /* If this is a div, then it's no longer collapsible content and doesn't need to be shown. */
  &:is(div) {
    display: none;
  }

  &.expanded {
    --_toggle-arrow-transform: rotate(180deg);
    margin-block-start: 14px;

    .toggle-show-label {
      display: none;
    }

    .toggle-hide-label {
      display: inline-block;
    }
  }

  > svg {
    stroke: currentColor;
    stroke-width: 0.5px;
    transform: var(--_toggle-arrow-transform);
  }

  .toggle-hide-label {
    display: none;
  }
`;

export const Content = styled(Collapse.Content)`
  position: relative;

  &:focus-visible {
    ${defaultFocusStyle}
  }

  &.collapse__content--hidden {
    pointer-events: none;
  }
`;

export const Overlay = styled.div`
  --Overlay-bg: rgba(247, 247, 247, 1);
  --Overlay-bg-transparent: rgba(247, 247, 247, 0);

  .overlay-full &,
  .notes-list & {
    --Overlay-bg: rgba(236, 236, 236, 1);
    --Overlay-bg-transparent: rgba(236, 236, 236, 0);

    ${({ $light }) =>
      $light &&
      `  --Overlay-bg: rgba(247, 247, 247, 1);
      --Overlay-bg-transparent: rgba(247, 247, 247, 0);
  `}
  }

  .scheme-dark & {
    --Overlay-bg: rgba(46, 46, 46, 1);
    --Overlay-bg-transparent: rgba(46, 46, 46, 0);
  }

  .scheme-dark .overlay-full & {
    --Overlay-bg: rgba(54, 54, 54, 1);
    --Overlay-bg-transparent: rgba(54, 54, 54, 0);
  }

  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  opacity: 1;
  background: linear-gradient(
    var(--Overlay-bg-transparent),
    80%,
    var(--Overlay-bg)
  );
  transition: opacity var(--collapse-duration) ease var(--collapse-delay),
    visibility var(--collapse-duration);

  .collapse__content--visible & {
    opacity: 0;
  }
`;
